// extracted by mini-css-extract-plugin
export var closeButton = "_n9-1";
export var closeX = "_n9-3";
export var container = "_n9-0";
export var image = "_n9-2";